import React from 'react';
import { motion } from "framer-motion";
import { registrarTiempos, registrarRecordsPws, registrarTiemposFamilia, registrarRecordEvento } from '../controllers/configuracionFirebase';
import { Button } from 'primereact/button';

const TablaTiempos = ({pruebas, nadadores, idTorneoParticipando, torneoEspecifico, tiemposRegistrados, setTiemposRegistrados, listadoCategorias, formulariosRef, seriesRef, recordsEvento, fechaGoogle, hablarPreventivo, hablarPausar, hablarDefinitivo, voz}) => {

  function separarEdades(edad, auxNadadores, nad){
    if (!auxNadadores[edad]) {
      auxNadadores[edad] = [];
    }
    auxNadadores[edad].push(nad);
  }

  function generarId(idTabla, contadorIndex) {
    let decimalParte;

    if (contadorIndex < 10) {
      decimalParte = `.${contadorIndex}`;
    } else {
      let extra = contadorIndex - 9;
      let numNueves = Math.floor((extra - 1) / 9) + 1;
      let subIndex = ((extra - 1) % 9) + 1;
      decimalParte = `.${"9".repeat(numNueves)}${subIndex}`;
    }

    let idFinal = parseFloat(`${idTabla - 1}${decimalParte}`);
    return idFinal;
  }

  function manejarRegistroTiempos(nadadorObj, idTabla, auxTiemposRegistrados){
    for (let i = 0; i < nadadorObj.nadadores.length; i++) {
      const auxNadador = {
        carril: nadadorObj.nadadores[i].carril,
        serie: nadadorObj.nadadores[i].serie,
        nombre: nadadorObj.nadadores[i].nombre,
        club: nadadorObj.nadadores[i].club,
        identificacion: nadadorObj.nadadores[i].identificacion,
        edad: nadadorObj.nadadores[i].edad,
        nombreclub: nadadorObj.nadadores[i].nombreclub,
        categoria: nadadorObj.nadadores[i].categoria,
        genero: nadadorObj.nadadores[i].genero,
        fechaNacimiento: nadadorObj.nadadores[i].fechaNacimiento,
        codePais: nadadorObj.nadadores[i].codePais,
        departamento: nadadorObj.nadadores[i].departamento,
        equipo: nadadorObj.nadadores[i].equipo,
        record: nadadorObj.nadadores[i].record,
        tiempo: nadadorObj.nadadores[i].tiempoMin + ':' + nadadorObj.nadadores[i].tiempoSeg + ':' + nadadorObj.nadadores[i].tiempoMili,
        posicion: nadadorObj.nadadores[i].posicion,
        verificado: nadadorObj.nadadores[i].verificado,
        urlPhoto: nadadorObj.nadadores[i].urlPhoto,
        urlPhotoEq: nadadorObj.nadadores[i].urlPhotoEq,
      }
      nadadorObj.nadadores.splice(i, 1, auxNadador);
      nadadorObj.categoriaEdad = auxNadador.categoria;
      registrarRecordsPws(auxNadador.identificacion, nadadorObj.prueba, auxNadador.tiempo, auxNadador.record, auxNadador.posicion - 1, torneoEspecifico.carril, torneoEspecifico.piscina);
    }
    registrarTiempos(idTorneoParticipando, idTabla - 1, nadadorObj, auxTiemposRegistrados);
    registrarTiemposFamilia(idTorneoParticipando, idTabla - 1, nadadorObj);
  }

  function cambiarNombrePrueba(nuevoNombre, titulo, id){
    let auxNuevoNombre = '';
    if(titulo !== ''){
      auxNuevoNombre = pruebas[id].categoria.replace(titulo, nuevoNombre);
    }else{
      auxNuevoNombre = pruebas[id].categoria.replace(/\((M|F|X)\) \w+/g, (match) =>{
        return match.replace('/\b\w+\b/', nuevoNombre)});
    }
    return auxNuevoNombre;
  }

  function onSubmit(e){
    e.preventDefault();
    const id = e.target.id.value;
    const auxTiemposRegistrados = [...tiemposRegistrados];
    const idTabla = e.target.idTabla.value;
    auxTiemposRegistrados[parseInt(idTabla - 1)] = auxTiemposRegistrados[parseInt(idTabla - 1)] ? auxTiemposRegistrados[parseInt(idTabla - 1)] + 1 : 1;
    const nadadorObj = {
      id: parseInt(idTabla) - 1,
      categoriaDeportistas: pruebas[id].categoriaDeportistas,
      categoria: pruebas[id].categoria,
      prueba: pruebas[id].prueba,
      nadadores: [],
    }

    const auxCantSerie = auxTiemposRegistrados[parseInt(idTabla - 1)] <= nadadores[parseInt(idTabla - 1)].length ? auxTiemposRegistrados[parseInt(idTabla - 1)] : nadadores[parseInt(idTabla - 1)].length;
    
    let contadorCarril = parseInt(torneoEspecifico.carrilInicio); 
    for (let i = 0; i < parseInt(torneoEspecifico.carril); i++) {
      for (let j = 0; j < auxCantSerie; j++) {
        const carril = document.getElementById(`${idTabla - 1}carril${i}serie${j + 1}`).value;
        const serie = document.getElementById(`${idTabla - 1}serie${i}serie${j + 1}`).value;
        const nadador = document.getElementById(`${idTabla - 1}nombre${i}serie${j + 1}`).value;
        const club = document.getElementById(`${idTabla - 1}club${i}serie${j + 1}`).value;
        const nombreclub = document.getElementById(`${idTabla - 1}nombreclub${i}serie${j + 1}`).value;
        const cc = document.getElementById(`${idTabla - 1}identificacion${i}serie${j + 1}`).value;
        const edad = document.getElementById(`${idTabla - 1}edad${i}serie${j + 1}`).value;
        const record = document.getElementById(`${idTabla - 1}record${i}serie${j + 1}`).value;
        const equipo = document.getElementById(`${idTabla - 1}equipo${i}serie${j + 1}`) ? document.getElementById(`${idTabla - 1}equipo${i}serie${j + 1}`).value : '';
        const tiempoMin = document.getElementById(`${idTabla - 1}tiempo${contadorCarril}minserie${j + 1}`).value;
        const tiempoSeg = document.getElementById(`${idTabla - 1}tiempo${contadorCarril}segserie${j + 1}`).value;
        const tiempoMili = document.getElementById(`${idTabla - 1}tiempo${contadorCarril}miliserie${j + 1}`).value;
        const categoria = document.getElementById(`${idTabla - 1}categoria${i}serie${j + 1}`).value;
        const genero = document.getElementById(`${idTabla - 1}genero${i}serie${j + 1}`).value;
        const fechaNacimiento = document.getElementById(`${idTabla - 1}fechaNacimiento${i}serie${j + 1}`).value;
        const codePais = document.getElementById(`${idTabla - 1}codePais${i}serie${j + 1}`).value;
        const departamento = document.getElementById(`${idTabla - 1}departamento${i}serie${j + 1}`).value;
        const verificado = document.getElementById(`${idTabla - 1}verificado${i}serie${j + 1}`).value;
        const urlPhoto = document.getElementById(`${idTabla - 1}urlPhoto${i}serie${j + 1}`).value;
        const urlPhotoEq = document.getElementById(`${idTabla - 1}urlPhotoEq${i}serie${j + 1}`).value;

        if(nadador !== '' && club !== ''){
          const auxNadador = {
            carril,
            serie,
            nombre: nadador,
            club,
            identificacion: cc,
            edad,
            record,
            equipo: equipo !== '' ? equipo.split(',') : null,
            tiempoMin: parseInt(tiempoMin),
            tiempoSeg: parseInt(tiempoSeg),
            tiempoMili: parseInt(tiempoMili),
            nombreclub,
            categoria,
            genero,
            fechaNacimiento,
            codePais,
            departamento,
            verificado,
            urlPhoto,
            urlPhotoEq,
          }
          nadadorObj.nadadores.push(auxNadador);
        }
      }
      contadorCarril++;
    }

    nadadorObj.nadadores.sort(function(a, b) {
      var tiempoA = a.tiempoMin * 60 * 1000 + a.tiempoSeg * 1000 + a.tiempoMili;
      var tiempoB = b.tiempoMin * 60 * 1000 + b.tiempoSeg * 1000 + b.tiempoMili;

      if(a.tiempoMin === 0 && a.tiempoSeg === 0 && a.tiempoMili === 0){
        return 1;
      }else if(b.tiempoMin === 0 && b.tiempoSeg === 0 && b.tiempoMili === 0){
        return -1;
      }else{
        return tiempoA - tiempoB;
      }
    });

    let posicionActual = 1;
    let tiempoAnterior = null;
    let cantidadConPosicion = 0;

    for (let i = 0; i < nadadorObj.nadadores.length; i++) {
      let nadador = nadadorObj.nadadores[i];
      let tiempo = nadador.tiempoMin * 60 * 1000 + nadador.tiempoSeg * 1000 + nadador.tiempoMili;
    
      if (tiempo === 0 || nadador.tiempoMin === 61) {
        nadador.posicion = 9999;
        continue;
      }
    
      if (tiempo === tiempoAnterior) {
        nadador.posicion = posicionActual;
      } else {
        posicionActual = cantidadConPosicion + 1;
        nadador.posicion = posicionActual;
        cantidadConPosicion++;
      }
    
      tiempoAnterior = tiempo;
    }

    const auxCategoria = listadoCategorias.filter((listCate)=>{return listCate.valor === nadadorObj.categoriaDeportistas});
    if(auxCategoria.length !== 0){
      if(auxCategoria[0].premiacion === 'separados'){
        if(auxCategoria[0].grupos.length !== 0){
          const auxNadadores = {};
          for (let i = 0; i < nadadorObj.nadadores.length; i++) {
            const edad = nadadorObj.nadadores[i].categoria;
            const auxGrupo = auxCategoria[0].grupos.filter((gru)=>{return (gru.edadInicio === gru.edadFin ? gru.edadInicio : (gru.edadFin === "999" ? gru.edadInicio + ' y Mas' : gru.edadInicio + ' - ' + gru.edadFin)) === edad});
            if(auxGrupo.length !== 0){
              if(parseInt(auxGrupo[0].edadInicio) <= parseInt(nadadorObj.nadadores[i].edad) && parseInt(auxGrupo[0].edadFin) >= parseInt(nadadorObj.nadadores[i].edad)){
                separarEdades(edad, auxNadadores, nadadorObj.nadadores[i]);
              }
            }
          }
          let contadorIndex = 0;
          auxCategoria[0].grupos.forEach((ed) =>{
            const juntarEdades = ed.edadInicio === ed.edadFin ? ed.edadInicio : (ed.edadFin === "999" ? ed.edadInicio + ' y Mas' : ed.edadInicio + ' - ' + ed.edadFin);
            if(auxNadadores[juntarEdades]){
              const objNadador = {
                id: generarId(idTabla, contadorIndex),
                categoriaDeportistas: pruebas[id].categoriaDeportistas,
                categoria: cambiarNombrePrueba(`${ed.nombre} Años`, auxCategoria[0].titulo === '' ? auxCategoria[0].grupos[0].edadInicio + ' - ' + auxCategoria[0].grupos[auxCategoria[0].grupos.length - 1].edadFin + ' Años' : auxCategoria[0].titulo, id),
                prueba: pruebas[id].prueba,
                nadadores: [],
              }

              let posicionActual = 1;
              let tiempoAnterior = null;
              let cantidadConPosicion = 0;

              for (let i = 0; i < auxNadadores[juntarEdades].length; i++) {
                let nadador = auxNadadores[juntarEdades][i];
                let tiempo = nadador.tiempoMin * 60 * 1000 + nadador.tiempoSeg * 1000 + nadador.tiempoMili;
              
                if (tiempo === 0 || nadador.tiempoMin === 61) {
                  nadador.posicion = 9999;
                  continue;
                }
              
                if (tiempo === tiempoAnterior) {
                  nadador.posicion = posicionActual;
                } else {
                  posicionActual = cantidadConPosicion + 1;
                  nadador.posicion = posicionActual;
                  cantidadConPosicion++;
                }
              
                tiempoAnterior = tiempo;
              }

              const guardarNadadoresSeparados = [];
              auxNadadores[juntarEdades].forEach((auxNad, indexAuxNad)=>{
                const auxNadador = {
                  carril: auxNad.carril,
                  serie: auxNad.serie,
                  nombre: auxNad.nombre,
                  club: auxNad.club,
                  identificacion: auxNad.identificacion,
                  edad: auxNad.edad,
                  nombreclub: auxNad.nombreclub,
                  categoria: auxNad.categoria,
                  genero: auxNad.genero,
                  fechaNacimiento: auxNad.fechaNacimiento,
                  codePais: auxNad.codePais,
                  departamento: auxNad.departamento,
                  equipo: auxNad.equipo,
                  record: auxNad.record,
                  tiempo: auxNad.tiempoMin + ':' + auxNad.tiempoSeg + ':' + auxNad.tiempoMili,
                  posicion: auxNad.posicion,
                  verificado: auxNad.verificado,
                  urlPhoto: auxNad.urlPhoto,
                  urlPhotoEq: auxNad.urlPhotoEq,
                }

                objNadador.categoriaEdad = auxNadador.categoria;
                guardarNadadoresSeparados.push(auxNadador);
                registrarRecordsPws(auxNadador.identificacion, objNadador.prueba, auxNadador.tiempo, auxNadador.record, auxNadador.posicion - 1, torneoEspecifico.carril, torneoEspecifico.piscina);
              })
              objNadador.nadadores = guardarNadadoresSeparados;
              registrarTiempos(idTorneoParticipando, objNadador.id, objNadador, auxTiemposRegistrados);
              registrarTiemposFamilia(idTorneoParticipando, objNadador.id, objNadador);
              contadorIndex++;
            }
          })
        }else{
          manejarRegistroTiempos(nadadorObj, idTabla, auxTiemposRegistrados);
        }
      }else{
        manejarRegistroTiempos(nadadorObj, idTabla, auxTiemposRegistrados);
      }
    }
    registrarRecordEvento(nadadores, nadadorObj, torneoEspecifico, recordsEvento, fechaGoogle);
    setTiemposRegistrados(auxTiemposRegistrados);
  }

  return (
    <>
      <div className='d-flex flex-wrap justify-content-center'>
        {pruebas.map((prue, indexPrue)=>{
          return <form key={indexPrue} ref={(el) => (formulariosRef.current[prue.id] = el)} onSubmit={onSubmit} className='formulario-tablas'>
            <motion.table
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{duration: 1}}
            className='table table-striped table-hover table-bordered table-light shadow tabla-tiempos'
            style={{margin: '4px', width: '640px'}}
            >
              <thead>
                <tr>
                  <th className='id fs-4'>
                    <input type="hidden" name='idTabla' defaultValue={prue.id}/>
                    <input type="hidden" name='id' defaultValue={indexPrue}/>{prue.id}
                  </th>
                  <th colSpan={3}>{prue.categoria}</th>
                </tr>
                <tr>
                  <th colSpan={4}>{prue.prueba.prueba}</th>
                </tr>
              </thead>
              {
                nadadores[prue.id - 1] ?
                nadadores[prue.id - 1].length !== 0 ?
                nadadores[prue.id - 1].map((nadador, nadadorIndex)=>{
                  return <tbody key={nadadorIndex} ref={(el) => (seriesRef.current[`${prue.id}-${nadador.Serie}`] = el)}>
                    <tr>
                      <th colSpan={2}>{`Serie ${nadador.Serie}: ${tiemposRegistrados[prue.id - 1] ? tiemposRegistrados[prue.id - 1] >= nadador.Serie ? 'Registrada' : 'No se ha registrado aún' : 'No se ha registrado aún'}`}</th>
                      <th colSpan={2}>
                        {voz && <Button type="button" label='P' className='btn btn-info py-1 me-1' onClick={() => hablarPreventivo(prue, nadadores[prue.id - 1], nadador.Serie)}/>}
                        {voz && <Button type="button" icon='pi pi-pause-circle' className='py-1 rounded-3' severity='danger' onClick={() => hablarPausar()}/>}
                        {voz && <Button type="button" label='D' className='btn btn-info py-1 mx-1' onClick={() => hablarDefinitivo(prue, nadadores[prue.id - 1], nadador.Serie)}/>}
                        <Button type="submit" icon='pi pi-stopwatch' className='py-1 rounded-3' severity={`${tiemposRegistrados[prue.id - 1] ? tiemposRegistrados[prue.id - 1] >= nadador.Serie ? 'success' : 'danger' : 'danger'}`} disabled={nadadores[prue.id - 1] ? nadadores[prue.id - 1].length !== 0 ? false: true : true}/>
                      </th>  
                    </tr>
                    {
                      nadador.nadadores.map((user, index)=>{
                        return <tr key={index}>
                          <td>{user.carril}</td>
                          {user.equipo ?(
                            <td className='dropdown'>
                              <span className='btn btn-secondary btn-sm dropdown-toggle' id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                              <input type="hidden" id={`${prue.id - 1}nombre${index}serie${nadador.Serie}`} defaultValue={user.nombre}/>{user.nombre}</span>
                              <input type="hidden" id={`${prue.id - 1}equipo${index}serie${nadador.Serie}`} defaultValue={user.equipo}/>
                              <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                {user.equipo.map((eq, indexEq)=>{
                                  return <li key={indexEq} className="dropdown-item">{eq + '/' + user.edades[indexEq]}</li>
                                })}
                              </ul>
                            </td>
                            ):(
                            <td><input type="hidden" id={`${prue.id - 1}nombre${index}serie${nadador.Serie}`} defaultValue={user.nombre}/>{user.nombre}</td>
                          )}
                          <td><input type="hidden" id={`${prue.id - 1}club${index}serie${nadador.Serie}`} defaultValue={user.club}/>{user.club}</td>
                          <td style={{display: 'none'}}><input type="hidden" id={`${prue.id - 1}carril${index}serie${nadador.Serie}`} defaultValue={user.carril}/></td>
                          <td style={{display: 'none'}}><input type="hidden" id={`${prue.id - 1}serie${index}serie${nadador.Serie}`} defaultValue={nadador.Serie}/></td>
                          <td style={{display: 'none'}}><input type="hidden" id={`${prue.id - 1}nombreclub${index}serie${nadador.Serie}`} defaultValue={user.nombreclub}/></td>
                          <td style={{display: 'none'}}><input type="hidden" id={`${prue.id - 1}identificacion${index}serie${nadador.Serie}`} defaultValue={user.identificacion}/></td>
                          <td style={{display: 'none'}}><input type="hidden" id={`${prue.id - 1}edad${index}serie${nadador.Serie}`} defaultValue={user.edad}/></td>
                          <td style={{display: 'none'}}><input type="hidden" id={`${prue.id - 1}record${index}serie${nadador.Serie}`} defaultValue={user.record}/></td>
                          <td style={{display: 'none'}}><input type="hidden" id={`${prue.id - 1}categoria${index}serie${nadador.Serie}`} defaultValue={user.categoria}/></td>
                          <td style={{display: 'none'}}><input type="hidden" id={`${prue.id - 1}genero${index}serie${nadador.Serie}`} defaultValue={user.genero}/></td>
                          <td style={{display: 'none'}}><input type="hidden" id={`${prue.id - 1}fechaNacimiento${index}serie${nadador.Serie}`} defaultValue={user.fechaNacimiento}/></td>
                          <td style={{display: 'none'}}><input type="hidden" id={`${prue.id - 1}codePais${index}serie${nadador.Serie}`} defaultValue={user.codePais}/></td>
                          <td style={{display: 'none'}}><input type="hidden" id={`${prue.id - 1}departamento${index}serie${nadador.Serie}`} defaultValue={user.departamento}/></td>
                          <td style={{display: 'none'}}><input type="hidden" id={`${prue.id - 1}verificado${index}serie${nadador.Serie}`} defaultValue={user.verificado}/></td>
                          <td style={{display: 'none'}}><input type="hidden" id={`${prue.id - 1}urlPhoto${index}serie${nadador.Serie}`} defaultValue={user.urlPhoto}/></td>
                          <td style={{display: 'none'}}><input type="hidden" id={`${prue.id - 1}urlPhotoEq${index}serie${nadador.Serie}`} defaultValue={user.urlPhotoEq}/></td>
                          <td style={{width: '40%'}}>
                            <div>
                              <input className='text-center cro' disabled={user.nombre.length !== 0 ? false : true} style={{width: '30%'}} type="number" min='0' id={`${prue.id - 1}tiempo${user.carril}minserie${nadador.Serie}`} defaultValue={user.tiempoBackup ? parseInt(user.tiempoBackup[0]) : '0'} required/>:
                              <input className='text-center cro' disabled={user.nombre.length !== 0 ? false : true} style={{width: '30%'}} type="number" id={`${prue.id - 1}tiempo${user.carril}segserie${nadador.Serie}`} defaultValue={user.tiempoBackup ? parseInt(user.tiempoBackup[1]) : '0'} required/>.
                              <input className='text-center cro' disabled={user.nombre.length !== 0 ? false : true} style={{width: '30%'}} type="number" min='0' id={`${prue.id - 1}tiempo${user.carril}miliserie${nadador.Serie}`} defaultValue={user.tiempoBackup ? parseInt(user.tiempoBackup[2]) : '0'} required/>
                            </div>
                          </td>
                        </tr>
                      })
                    }
                  </tbody>
                })
                :
                <tbody>
                  <tr>
                    <th colSpan={3}>Serie 1</th>
                  </tr>
                  <tr>
                    <td colSpan={3}>No hay nadadores aún</td>
                  </tr>
                </tbody>
                :
                <tbody>
                  <tr>
                    <th colSpan={3}>Serie 1</th>
                  </tr>
                  <tr>
                    <td colSpan={3}>No hay nadadores aún</td>
                  </tr>
                </tbody>
              }
            </motion.table>
          </form>
        })}
      </div>
    </>
  );
}

export default TablaTiempos;